import { render } from "./MoonSpace.vue?vue&type=template&id=38067080&ts=true"
import script from "./MoonSpace.vue?vue&type=script&lang=ts"
export * from "./MoonSpace.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__